import { ESTADOS } from './brasil';

const CORES = [
  ['azul', 'Azul'],
  ['verde', 'Verde'],
  ['vermelho', 'Vermelho'],
  ['laranja', 'Laranja'],
  ['marinho', 'Azul-marinho'],
  ['amarelo', 'Amarelo (para o fundo azul)'],
];
const MARCADORES = [
  ['cheio', 'Círculo cheio'],
  ['vazado', 'Círculo vazado'],
  ['quadrado', 'Quadrado'],
  ['anel', 'Círculo com anel amarelo'],
];

/** Campos do bloco; os do modo que não está em uso ficam escondidos. */
const MapaSchema = ({ data = {} } = {}) => {
  const estados = data.modo === 'estados';
  const categorias = (data.categorias || [])
    .filter((c) => c && c['@id'])
    .map((c) => [c['@id'], (c.nome || '').trim() || 'Sem nome']);
  return {
    title: 'AgSUS Mapa do Brasil',
    fieldsets: [
      {
        id: 'default',
        title: 'Mapa',
        fields: [
          'modo',
          'fundo',
          'etiqueta',
          'titulo',
          'nivel',
          'subtitulo',
          'fonte',
        ],
      },
      estados
        ? {
            id: 'estados',
            title: 'Valor por estado',
            fields: ['valores', 'unidade', 'unidadeSingular', 'lista'],
          }
        : {
            id: 'pontos',
            title: 'Pontos',
            fields: ['categorias', 'pontos', 'lista', 'numerar', 'contagem'],
          },
    ],
    properties: {
      modo: {
        title: 'O que o mapa mostra',
        choices: [
          ['pontos', 'Pontos em cidades'],
          ['estados', 'Um número por estado'],
        ],
        default: 'pontos',
        noValueOption: false,
      },
      fundo: {
        title: 'Fundo',
        choices: [
          ['branco', 'Cartão branco, na coluna do texto'],
          ['azul', 'Faixa azul, com a lista ao lado do mapa'],
        ],
        default: 'branco',
        noValueOption: false,
      },
      etiqueta: {
        title: 'Etiqueta',
        description: 'Texto curto em caixa alta. Ex.: Bases regionais',
      },
      titulo: {
        title: 'Título',
        description:
          'A frase que o leitor deve levar. Ex.: Cinco bases já funcionam; outras quatro estão previstas até dezembro',
      },
      nivel: {
        title: 'Nível do título',
        choices: [
          ['h2', 'Intertítulo (H2)'],
          ['h3', 'Subtítulo (H3)'],
        ],
        default: 'h2',
        noValueOption: false,
      },
      subtitulo: {
        title: 'Texto sob o título',
        widget: 'textarea',
        description:
          'Data, recorte, unidade. Ex.: Situação em 22 de outubro de 2026.',
      },
      fonte: {
        title: 'Fonte, sob o mapa',
        description:
          'Ex.: Endereços: Relatório de Gestão 2025. Malha dos estados: IBGE.',
      },
      categorias: {
        title: 'Categorias',
        description:
          'Cada uma vira um item da legenda, com o seu marcador e a sua cor. Sem categoria, todos os pontos ficam iguais.',
        widget: 'object_list',
        schema: {
          title: 'Categoria',
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['nome', 'marcador', 'cor'],
            },
          ],
          properties: {
            nome: { title: 'Nome na legenda' },
            marcador: {
              title: 'Marcador',
              choices: MARCADORES,
              default: 'cheio',
            },
            cor: {
              title: 'Cor',
              choices: CORES,
              description: 'Vazio: amarelo no fundo azul, azul no branco.',
            },
          },
          required: [],
        },
      },
      pontos: {
        title: 'Pontos',
        description:
          'Mais rápido: cole a lista no campo "Colar a lista de pontos", abaixo do bloco. O ponto vai para a sede do município.',
        widget: 'object_list',
        schema: {
          title: 'Ponto',
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['cidade', 'categoria', 'detalhe', 'link', 'rotulo'],
            },
          ],
          properties: {
            cidade: {
              title: 'Cidade (UF)',
              description: 'Ex.: Porto Velho (RO)',
            },
            categoria: {
              title: 'Categoria',
              choices: categorias,
            },
            detalhe: {
              title: 'Detalhe',
              description: 'Aparece na lista e ao passar o mouse no ponto.',
            },
            link: { title: 'Link', description: 'Opcional.' },
            rotulo: {
              title: 'Nome da cidade no mapa',
              type: 'boolean',
              description:
                'Se o nome esbarrar em outro, ele se esconde naquela largura de tela.',
            },
          },
          required: [],
        },
      },
      lista: {
        title: 'Mostrar a lista (dos pontos ou dos números)',
        type: 'boolean',
        default: true,
        description:
          'Desmarque quando a página já traz os mesmos lugares ou números logo abaixo.',
      },
      numerar: {
        title: 'Numerar os pontos',
        type: 'boolean',
        description: 'O número no mapa corresponde à posição na lista.',
      },
      contagem: {
        title: 'Contagem na legenda',
        type: 'boolean',
        default: true,
        description: 'Ex.: "Em funcionamento · 5".',
      },
      valores: {
        title: 'Valores',
        widget: 'object_list',
        schema: {
          title: 'Estado',
          fieldsets: [
            { id: 'default', title: 'Default', fields: ['uf', 'valor'] },
          ],
          properties: {
            uf: {
              title: 'Estado',
              choices: ESTADOS.map((e) => [e.uf, e.nome]),
            },
            valor: { title: 'Valor', type: 'number' },
          },
          required: [],
        },
      },
      unidade: {
        title: 'Unidade (plural)',
        description: 'Ex.: turmas',
      },
      unidadeSingular: {
        title: 'Unidade (singular)',
        description: 'Ex.: turma. Usada quando o valor é 1.',
      },
    },
    required: [],
  };
};

export default MapaSchema;
